export default __webpack_public_path__ + "static/media/arrow.9a200a0b.svg";